import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import createActivityDetector from './detector';
import { guslStorage } from 'src/providers/session/GuslStorage.ts';
import { VISIONX_CONSTANTS } from 'src/app/ComponentMap.tsx';
import useGetTimeToIdle from 'src/app/custom-hooks/useGetTimeToIdle.tsx';
const DEFAULT_TIME_TO_IDLE = 0;

function getTimeToIdle(stringTimeToIdle?: string | number | null): number {
  if (typeof stringTimeToIdle === 'number') return stringTimeToIdle;

  let result = DEFAULT_TIME_TO_IDLE;

  if (stringTimeToIdle != null) {
    switch (stringTimeToIdle) {
      case '10min':
        result = 10 * 60 * 1_000;
        break;
      case '30min':
        result = 30 * 60 * 1_000;
        break;
      case '1hr':
        result = 60 * 60 * 1_000;
        break;
      case '6hrs':
        result = 6 * 60 * 60 * 1_000;
        break;
      case '24hrs':
        result = 24 * 60 * 60 * 1_000;
        break;
      case '10ds':
        result = 10 * 24 * 60 * 60 * 1_000;
        break;
      case '20ds':
        result = 20 * 24 * 60 * 60 * 1_000;
        break;
      case 'never':
        result = 0;
        break;
      default:
        console.warn(`Invalid timeToIdle: ${stringTimeToIdle}`);
    }
  }

  return result;
}
export default function ActivityDetector() {
  const navigate = useNavigate();
  const stringToIdle = useGetTimeToIdle();
  const timeToIdle = getTimeToIdle(stringToIdle);
  const hasSession: boolean = guslStorage.hasSession();

  useEffect(() => {
    if (!hasSession || timeToIdle === 0) {
      return;
    }

    const activityDetector = createActivityDetector({
      timeToIdle,
      autoInit: false,
    });

    function handleUserIdle() {
      guslStorage.clearSession();
      activityDetector.stop();
      navigate(VISIONX_CONSTANTS.SESSION_EXPIRED_PATH);
    }

    activityDetector.on('idle', handleUserIdle);
    activityDetector.init();

    return () => {
      activityDetector.stop();
    };
  }, [hasSession, timeToIdle, navigate]);

  return null;
}
